export const APPLICATION_RESET_STATE = "APPLICATION_RESET_STATE"
export const APPLICATION_RESET_STATE_SUCCESSFUL = "APPLICATION_RESET_STATE_SUCCESSFUL"
export const APPLICATION_RESET_STATE_FAILED = "APPLICATION_RESET_STATE_FAILED"

export const APPLICATION_PERSONAL_INFORMATION = "APPLICATION_PERSONAL_INFORMATION"
export const APPLICATION_PERSONAL_INFORMATION_SUCCESSFUL =
  "APPLICATION_PERSONAL_INFORMATION_SUCCESSFUL"
export const APPLICATION_PERSONAL_INFORMATION_FAILED = "APPLICATION_PERSONAL_INFORMATION_FAILED"

export const APPLICATION_UPDATE_ADDRESS = "APPLICATION_UPDATE_ADDRESS"
export const APPLICATION_UPDATE_ADDRESS_SUCCESSFUL =
  "APPLICATION_UPDATE_ADDRESS_SUCCESSFUL"
export const APPLICATION_UPDATE_ADDRESS_FAILED = "APPLICATION_UPDATE_ADDRESS_FAILED"

export const APPLICATION_INCOME_INFORMATION = "APPLICATION_INCOME_INFORMATION"
export const APPLICATION_INCOME_INFORMATION_SUCCESSFUL =
  "APPLICATION_INCOME_INFORMATION_SUCCESSFUL"
export const APPLICATION_INCOME_INFORMATION_FAILED = "APPLICATION_INCOME_INFORMATION_FAILED"

export const APPLICATION_RESIDENCY_INFORMATION = "APPLICATION_RESIDENCY_INFORMATION"
export const APPLICATION_RESIDENCY_INFORMATION_SUCCESSFUL =
  "APPLICATION_RESIDENCY_INFORMATION_SUCCESSFUL"
export const APPLICATION_RESIDENCY_INFORMATION_FAILED = "APPLICATION_RESIDENCY_INFORMATION_FAILED"

export const APPLICATION_REFERENCE_INFORMATION = "APPLICATION_REFERENCE_INFORMATION"
export const APPLICATION_REFERENCE_INFORMATION_SUCCESSFUL =
  "APPLICATION_REFERENCE_INFORMATION_SUCCESSFUL"
export const APPLICATION_REFERENCE_INFORMATION_FAILED = "APPLICATION_REFERENCE_INFORMATION_FAILED"

export const APPLICATION_ACCESS_CODE = "APPLICATION_ACCESS_CODE"
export const APPLICATION_ACCESS_CODE_SUCCESSFUL =
  "APPLICATION_ACCESS_CODE_SUCCESSFUL"
export const APPLICATION_ACCESS_CODE_FAILED = "APPLICATION_ACCESS_CODE_FAILED"

export const APPLICATION_VALIDATE_ACCESS_CODE = "APPLICATION_VALIDATE_ACCESS_CODE"
export const APPLICATION_VALIDATE_ACCESS_CODE_SUCCESSFUL =
  "APPLICATION_VALIDATE_ACCESS_CODE_SUCCESSFUL"
export const APPLICATION_VALIDATE_ACCESS_CODE_FAILED = "APPLICATION_VALIDATE_ACCESS_CODE_FAILED"

export const APPLICATION_START_CO_SIGNER = "APPLICATION_START_CO_SIGNER"
export const APPLICATION_START_CO_SIGNER_SUCCESSFUL =
  "APPLICATION_START_CO_SIGNER_SUCCESSFUL"
export const APPLICATION_START_CO_SIGNER_FAILED = "APPLICATION_START_CO_SIGNER_FAILED"

export const APPLICATION_INVITE_CO_EMAIL = "APPLICATION_INVITE_CO_EMAIL"
export const APPLICATION_INVITE_CO_EMAIL_SUCCESSFUL =
  "APPLICATION_INVITE_CO_EMAIL_SUCCESSFUL"
export const APPLICATION_INVITE_CO_EMAIL_FAILED = "APPLICATION_INVITE_CO_EMAIL_FAILED"

export const APPLICATION_INVITE_CO_SMS = "APPLICATION_INVITE_CO_SMS"
export const APPLICATION_INVITE_CO_SMS_SUCCESSFUL =
  "APPLICATION_INVITE_CO_SMS_SUCCESSFUL"
export const APPLICATION_INVITE_CO_SMS_FAILED = "APPLICATION_INVITE_CO_SMS_FAILED"